import React from 'react'
import './theme.scss'
import './app.scss'
import './applepay.scss'
import './swiper.bundle.scss'
import CartLayout from './layout/cart-layout'
import { renderRoutes } from 'react-router-config'
import routes from '../routes/shoppingcart'

import { IntlProvider } from 'react-intl'
import { getMessage, getLocale } from '../i18n'
import { useSelector } from 'react-redux'

// import Loadable from 'react-loadable'

import SwiperCore, {
	Pagination,
	Autoplay
} from 'swiper'
// import { Route, Switch } from 'react-router-dom'

SwiperCore.use([Pagination, Autoplay])

// const Loading = props => <span style={{position: 'fixed', top: 0}}/>

// const Details = Loadable({
// 	loader: () => import('./pages/details'),
// 	loading: Loading,
// })

const Index = props => {

	const global = useSelector((state) => state.global)

	return <IntlProvider messages={getMessage(global.language)} locale={getLocale(global.language)} defaultLocale="en">
        <CartLayout>
		{renderRoutes(routes)}
		{/* <Switch> */}
			
				{/* <Route path={'/product/:name/:id.html'} render={props => {
					return <BaseLayout>
						<Details {...props}/>
					</BaseLayout>
				}}/> */}

				{/* <Route path={'/cart/product/:name/:id.html'} component={Details}/> */}
			
		{/* </Switch>	 */}
		<div id="alert-container"></div>
		<div id="confirm-container"></div>
		<div id="toast-container"></div>
        </CartLayout>
	</IntlProvider>

}


export default Index